<template>
  <VMenu
    v-model="showLangSelector"
    offset-y
    bottom
  >
    <template v-slot:activator="{ on }">
      <VBtn
        text
        :color="color"
        class="landing-header__language font-weight-regular"
        v-on="on"
      >
        <VIcon class="mr-2 d-none d-sm-block">
          {{ mdiFlag }}
        </VIcon> {{ $vuetify.breakpoint.smAndUp ? currentLocale.text : currentLocale.short }}
        <VIcon class="landing-header__language-icon-down">
          {{ showLangSelector ? mdiMenuUp : mdiMenuDown }}
        </VIcon>
      </VBtn>
    </template>
    <VList>
      <VListItem
        v-for="it in languages"
        :key="it.text"
        @click="changeLanguage(it.value)"
      >
        {{ it.text }}
      </VListItem>
    </VList>
  </VMenu>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { mdiMenuDown, mdiMenuUp, mdiFlag } from '@mdi/js';
import useLocale from '@/compositions/useLocale';
import { localeType } from '../enums';

export default {
  name: 'LanguageSelect',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
  setup() {
    const { locale, changeLocale, saveLocale } = useLocale();
    const languages = [
      { text: 'English', short: 'En', value: localeType.EN },
      { text: 'Русский', short: 'Ру', value: localeType.RU },
    ];
    const currentLocale = computed(() => languages.find(it => it.value === locale.value));
    const showLangSelector = ref(false);

    function changeLanguage(language) {
      changeLocale(language);
      saveLocale(language);

      if (process.browser) {
        document.location.reload();
      }
    }

    return {
      languages,
      currentLocale,
      showLangSelector,
      mdiMenuDown,
      mdiMenuUp,
      mdiFlag,
      changeLanguage,
    };
  },
};
</script>
<style scoped lang="scss">
  .landing-header{
    &__language {
      font-size: 16px;
      margin-right: 10px;
    }
    &__language-icon-down {
      margin-left: 16px;
    }
  }

  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    .landing-header{
      &__language {
        font-size: 16px;
      }
    }
  }
</style>
